import firebase from "config/firebase";
import moment from "moment";
import { RepositoryFactory } from "../../repositroy/RepositoryFactory";
import { toast } from "react-toastify";

export const getAdditionalEarning = (month, byYear) => {
  return async (dispatch) => {
    var users = [];
    let data = [];
    let finalData = [];
    await firebase
      .firestore()
      .collection("license_purchases")
      .get()
      .then(async (query) => {
        for (let doc of query.docs) {
          if (
            moment.unix(doc.data().created_at?.seconds).format("M") == month &&
            moment.unix(doc.data().created_at?.seconds).format("YYYY") == byYear
          ) {
            users.push({ id: doc.id, ...doc.data() });
          }
        }
        users = users?.map((val) => {
          return {
            athlete_id: val?.athlete_id,
            amount: Number(val?.amount?.value) / 2,
          };
        });
      });

    await firebase
      .firestore()
      .collection("users")
      .get()
      .then((query) => {
        for (let doc of query.docs) {
          data.push({ id: doc.id, ...doc.data() });
        }
      });
    users?.map((val) => {
      let obj = data?.find((v) => v.id == val.athlete_id);
      let check = finalData?.find((v) => v.id == val.athlete_id);
      if (obj && !check) {
        finalData.push({
          id: obj?.id,
          athleteID: obj?.athleteID,
          name: obj?.first_name + " " + obj?.last_name,
          email: obj?.email,
          amount: val?.amount,
          created_at: obj?.created_at,
        });
      } else if (check) {
        let idx = finalData?.indexOf(check);
        finalData[idx].amount += val?.amount;
      }
    });
    dispatch({
      type: "GET_ADDITIONAL_EARNING",
      payload: finalData,
    });
  };
};

export const getLicenseEarnings =
  (id, onComplete = () => {}) =>
  async (dispatch) => {
    dispatch(loader(true));
    firebase
      .firestore()
      .collection("license_purchases")
      .where("athlete_id", "==", id)
      .onSnapshot(async (query) => {
        let temp_data = [];
        let totalLicenseEarnings = 0;
        for await (let doc of query.docs) {
          totalLicenseEarnings += parseFloat(doc.data().amount?.value);
          const user = await firebase
            .firestore()
            .collection("users")
            .doc(doc.data().fan_id)
            .get();
          temp_data.push({
            fanName: user.data()?.name,
            Amount: doc.data().amount?.value,
            ...doc.data(),
          });
        }
        dispatch({
          type: "GET_LICENSE_EARNINGS",
          payload: {
            totalEarnings: totalLicenseEarnings,
            data: temp_data,
          },
        });
        dispatch(loader(false));
        onComplete();
      });
  };

export const getSubscriptionEarnings =
  (id, onComplete = () => {}) =>
  async (dispatch) => {
    dispatch(loader(true));
    await firebase
      .firestore()
      .collection("license_subscriptions")
      .where("athlete_id", "==", id)
      .onSnapshot(async (query) => {
        let totalLicenseEarnings = 0;
        let temp_data = [];
        for (let doc of query.docs) {
          if (doc.data().amount.value) {
            totalLicenseEarnings += parseFloat(doc.data().amount.value);
          }
          let fanName = await firebase
            .firestore()
            .collection("users")
            .doc(doc.data().fan_id)
            .get();
          temp_data.push({
            Amount: doc.data().amount?.value,
            fanName: fanName.data().name,
            date: doc.data().created_at,
            ...doc.data(),
          });
        }
        dispatch({
          type: "GET_SUBSCRIPTION_EARNINGS",
          payload: {
            totalEarnings: totalLicenseEarnings,
            data: temp_data,
          },
        });
        onComplete();
        dispatch(loader(false));
      });
  };

export const getAthlete = (id) => async (dispatch) => {
  let user = await firebase.firestore().collection("users").doc(id).get();
  dispatch({
    type: "GET-ATHLETE",
    payload: user.data(),
  });
};

export const athleteAnnualEarning = (id, year) => (dispatch) => {
  const timeZoneRepository = RepositoryFactory.get("athleteStates");
  timeZoneRepository
    .getAthletePaymentStates(`${id}/${year}`)
    .then((response) => {
      const currentTime = response.data;
      dispatch({
        type: "ATHLETE_ANNUAL-EARNING",
        payload: currentTime,
      });
    })
    .catch((error) => {
      console.error(error);
    });
};

export const adminMonthlyEarningsByYear =
  (year, onComplete = () => {}) =>
  (dispatch) => {
    const timeZoneRepository = RepositoryFactory.get(
      "adminAllMonthEaringsByYear"
    );
    timeZoneRepository
      .getAdminEarningsByYear(`${year}`)
      .then((response) => {
        const input = Array.isArray(response.data.stats)
          ? response.data.stats
          : [];
        const allMonths = [
          { month: "Jan", earnings: 0 },
          { month: "Feb", earnings: 0 },
          { month: "Mar", earnings: 0 },
          { month: "Apr", earnings: 0 },
          { month: "May", earnings: 0 },
          { month: "Jun", earnings: 0 },
          { month: "Jul", earnings: 0 },
          { month: "Aug", earnings: 0 },
          { month: "Sep", earnings: 0 },
          { month: "Oct", earnings: 0 },
          { month: "Nov", earnings: 0 },
          { month: "Dec", earnings: 0 },
        ];
        const getAbbreviatedMonth = (fullMonth) => {
          const date = new Date(fullMonth + " 1");
          return date.toLocaleString("en-US", { month: "short" });
        };

        const inputMap = input?.reduce((acc, item) => {
          const monthAbbr = getAbbreviatedMonth(item.month);
          acc[monthAbbr] = item.total_earnings;
          return acc;
        }, {});
        const output = allMonths.map((month) => ({
          month: month.month,
          earnings: inputMap[month.month] || 0,
        }));
        dispatch({
          type: "ADMIN_MONTHLY_EARNING_BY_YEAR",
          payload: output,
        });
        onComplete();
      })
      .catch((error) => {
        console.error(error);
        onComplete();
      });
  };

export const adminEarningStats =
  (date, onComplete = () => {}) =>
  (dispatch) => {
    const timeZoneRepository = RepositoryFactory.get("adminStates");
    timeZoneRepository
      .getAdminPaymentStates(date)
      .then((response) => {
        const currentTime = response?.data?.stats;
        dispatch({
          type: "ADMIN_STATS",
          payload: currentTime,
        });
        onComplete();
      })
      .catch((error) => {
        console.error(error);
      });
  };
export const AllManagers =
  (onComplete = () => {}) =>
  (dispatch) => {
    const managers = RepositoryFactory.get("getAllManagers");
    managers
      .getAllManagers()
      .then((response) => {
        const managersData = response.data.managers;
        dispatch({
          type: "ALL_MANAGERS",
          payload: managersData,
        });
        onComplete();
      })
      .catch((error) => {
        console.error(error);
      });
  };
export const getSingleManager = (id) => (dispatch) => {
  const manager = RepositoryFactory.get("getManager");
  manager
    .getManager(id)
    .then((response) => {
      const managerData = response.data;
      dispatch({
        type: "GET_MANAGER",
        payload: managerData,
      });
    })
    .catch((error) => {
      console.error(error);
    });
};
export const refundsStates =
  (onComplete = () => {}) =>
  (dispatch) => {
    const refundRepository = RepositoryFactory.get("RefundsStates");
    refundRepository
      .getRefundsStates()
      .then((response) => {
        const currentData = response.data || {};
        let totalData = {
          satisfied: { totalChats: 0, totalRefunds: 0 },
          NS: { totalChats: 0, totalRefunds: 0 },
          RST: { totalChats: 0, totalRefunds: 0 },
          noRating: { totalChats: 0, totalRefunds: 0 },
        };
        
        if (currentData.satisfied && Array.isArray(currentData.satisfied)) {
          currentData.satisfied.forEach((items) => {
            totalData.satisfied.totalRefunds += items.refundAmount || 0;
            totalData.satisfied.totalChats++;
          });
        }
        
        if (currentData.NS && Array.isArray(currentData.NS)) {
          currentData.NS.forEach((items) => {
            totalData.NS.totalRefunds += items.refundAmount || 0;
            totalData.NS.totalChats++;
          });
        }
        
        if (currentData.RST && Array.isArray(currentData.RST)) {
          currentData.RST.forEach((items) => {
            totalData.RST.totalRefunds += items.refundAmount || 0;
            totalData.RST.totalChats++;
          });
        }
        
        if (currentData.noRating && Array.isArray(currentData.noRating)) {
          currentData.noRating.forEach((items) => {
            totalData.noRating.totalRefunds += items.refundAmount || 0;
            totalData.noRating.totalChats++;
          });
        }

        dispatch({
          type: "TOTAL-REFUNDS",
          payload: { totalData: totalData, data: currentData },
        });
        onComplete();
      })
      .catch((error) => {
        console.error(error);
        onComplete();
      });
  };

export const groupChatAction = (lastDocument, onComplete = () => {}) => {
  return async (dispatch) => {
    let quary = firebase
      .firestore()
      .collection("new_a4b_chat")
      .where("type", "==", "group");
    if (lastDocument) {
      quary = quary.startAfter(lastDocument);
    }
    quary
      .limit(5)
      .get()
      .then(async (query) => {
        let groupchat = [];

        for await (let doc of query.docs) {
          let athlete = await firebase
            .firestore()
            .collection("users")
            .doc(doc.data().athleteID)
            .get();
          let participantsData = [];
          doc.data().participants.forEach(async (participantId) => {
            let fan = await firebase
              .firestore()
              .collection("users")
              .doc(participantId)
              .get();
            participantsData.push(fan.exists ? fan.data() : null);
          });
          let timeslot = await firebase
            .firestore()
            .collection("a4b_athelete_timeslots")
            .doc(doc.data().time_slot_id)
            .get();

          groupchat.push({
            id: doc.id,
            ...doc.data(),
            athleteData: athlete.exists ? athlete.data() : null,
            fanData: participantsData,
            timeslotData: timeslot.exists ? timeslot.data() : null,
          });
        }
        dispatch({
          type: lastDocument ? "MORE_GET_GROUPCHAT" : "GET_GROUPCHAT",
          payload: {
            data: groupchat,
            lastDocument: query.docs[groupchat.length - 1],
            hasMore: groupchat.length >= 5,
          },
        });
        onComplete();
      });
  };
};

export const oneOnOneChatAction = (lastDocument, onComplete = () => {}) => {
  return async (dispatch) => {
    let quary = firebase
      .firestore()
      .collection("new_a4b_chat")
      .where("type", "!=", "group");
    if (lastDocument) {
      quary = quary.startAfter(lastDocument);
    }
    quary
      .limit(5)
      .get()
      .then(async (query) => {
        let oneononechat = [];
        for await (let doc of query.docs) {
          let athlete2 = await firebase
            .firestore()
            .collection("users")
            .doc(doc.data().athleteID)
            .get();
          let fan = await firebase
            .firestore()
            .collection("users")
            .doc(doc.data().participants[0])
            .get();
          oneononechat.push({
            id: doc.id,
            ...doc.data(),
            athleteData: athlete2.data(),
            fanData: fan.data(),
          });
        }
        dispatch({
          type: lastDocument ? "MORE_GET_ONEONONECHAT" : "GET_ONEONONECHAT",
          payload: {
            data: oneononechat,
            lastDocument: query.docs[oneononechat.length - 1],
            hasMore: oneononechat.length >= 5,
          },
        });
        onComplete();
      });
  };
};

export const loader = (val) => (dispatch) => {
  dispatch({
    type: "LOADER",
    payload: val,
  });
};

export const fetchUserStats = (data, onComplete = () => {}) => {
  return async (dispatch) => {
    try {
      const querySnapshot = await firebase
        .firestore()
        .collection("annualUserStats")
        .where("year", "==", data)
        .get();

      const stats = [];
      querySnapshot.forEach((doc) => {
        stats.push({ id: doc.id, ...doc.data() });
      });

      dispatch({
        type: "GET_USER_STATS",
        payload: stats,
      });

      onComplete();
    } catch (error) {
      console.error("Error fetching coin stats:", error);
      toast.error("Failed to fetch coin stats");
      onComplete();
    }
  };
};

export const fetchCoinsStats =
  (data, onComplete = () => {}) =>
  async (dispatch) => {
    try {
      dispatch({ type: "CLEAR_TRANSACTIONS" });

      const fetchCoins = RepositoryFactory.get("getCoinsStats");

      const response = await fetchCoins.getCoinsStats(data);

      const transactions = response.data?.data?.transactions || [];

      dispatch({
        type: "SET_COINS_STATS",
        payload: transactions,
      });
      onComplete();
    } catch (error) {
      toast.error("UserID  not found");
      console.error("Fetch coins stats error:", error);
      onComplete();
    }
  };

export const coinsDistributionStats =
  (onComplete = () => {}) =>
  async (dispatch) => {
    try {
      const fetchCoinsStats = RepositoryFactory.get("getCoinsStats");
      const response = await fetchCoinsStats.getCoinsDistributionStats();
      const data = response.data.data;
      dispatch({
        type: "SET_DISTRIBUTED_COINS_STATS",
        payload: data,
      });
      onComplete();
    } catch (error) {
      toast.error("Failed to fetch distribution stats");
      console.error("Fetch coins stats error:", error);
      onComplete();
    }
  };
